module.exports = __webpack_public_path__ + "static/img/img_logo.c3f5b805.png";